/**
 * Sessions API Client
 *
 * Handles all session-related API calls:
 * - Create session
 * - Get session details
 * - Close session
 */

import apiClient from './client';
import type { SessionCreateRequest, SessionResponse, SessionCloseResponse } from '../types/api';

export const sessionsApi = {
  /**
   * Create a new PDF processing session
   */
  createSession: async (data: SessionCreateRequest): Promise<SessionResponse> => {
    const response = await apiClient.post('/api/v1/sessions/', data);
    return response.data;
  },

  /**
   * Get session details by ID
   */
  getSession: async (sessionId: string, customerId: string): Promise<SessionResponse> => {
    const response = await apiClient.get(`/api/v1/sessions/${sessionId}`, {
      params: { customer_id: customerId },
    });
    return response.data;
  },

  /**
   * Close an active session
   */
  closeSession: async (sessionId: string, customerId: string): Promise<SessionCloseResponse> => {
    const response = await apiClient.post(`/api/v1/sessions/${sessionId}/close`, null, {
      params: { customer_id: customerId },
    });
    return response.data;
  },
};
